import type { CompendiumKind } from "./compendium";

export interface CompendiumSection {
  kind: CompendiumKind;
  /** The address folder for this kind, also the anchor of its list on the series page. */
  folder: string;
  title: (seriesId: string) => string;
}

/** Every kind of compendium page, in the order the series page lists them. */
export const COMPENDIUM_SECTIONS: readonly CompendiumSection[] = [
  {
    kind: "race",
    folder: "races",
    title: (seriesId) => (seriesId === "animorphs" ? "Alien races" : "Peoples"),
  },
  { kind: "vehicle", folder: "vehicles", title: () => "Vehicles" },
  { kind: "organization", folder: "organizations", title: () => "Organizations" },
  { kind: "business", folder: "businesses", title: () => "Businesses" },
  { kind: "spell", folder: "spells", title: () => "Spells" },
  { kind: "morph", folder: "morphs", title: () => "Morphs" },
  { kind: "item", folder: "items", title: () => "Key items" },
];

export function sectionFromFolder(folder: string | undefined): CompendiumSection | undefined {
  return COMPENDIUM_SECTIONS.find((section) => section.folder === folder);
}
